module.exports = __webpack_public_path__ + "img/RX-Arcos-5-zoom.c1eaa5d7.png";